export class DrillingHoleType {
  public static readonly SQUARE_TYPE: string = 'square';
  public static readonly CIRCLE_TYPE: string = 'circle';
  public static readonly SLOT_TYPE: string = 'slot';
}
